import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import Translator from '../../../components/helpers/Translator';
import colors from '../../../../constants/colors';
import AppLink from '../../../../routing/helpers/AppLink';

export default function CommunicationPipelineStatusStep(props) {
  const {
    currentStatus,
    statusStep,
    statusInfo,
    statusDate,
    isAdmin = false,
  } = props;
  const { moduleBridgeHex, reportHex } = useParams();
  const [isBlock, setIsBlock] = useState();

  useEffect(() => {
    setIsBlock(
      currentStatus?.step === 'sign' &&
        currentStatus?.progress === 'denied' &&
        statusStep?.value !== 'sent' &&
        statusStep?.value !== 'sign'
    );
  }, []);

  const title = useCallback(() => {
    const children = statusStep?.label;
    const className = 'd-block text-muted mb-0 mb-lg-0';

    if (statusStep?.value === 'sent') {
      return (
        <AppLink
          className={className}
          path={`user_module_communicationPipeline_${
            isAdmin ? 'admin' : 'user'
          }_report_sent`}
          params={{
            moduleBridgeHex,
            reportHex,
            type: statusStep?.name,
          }}
        >
          {children}
        </AppLink>
      );
    }

    if (isAdmin && !isBlock) {
      return (
        <AppLink
          className={className}
          path={`user_module_communicationPipeline_admin_report_${statusStep?.value}`}
          params={{
            moduleBridgeHex,
            reportHex,
            type: statusStep?.name,
          }}
        >
          {children}
        </AppLink>
      );
    }

    return <span className={className}>{children}</span>;
  }, [statusStep, isBlock]);

  const date = useCallback(() => {
    if (statusDate?.[statusInfo?.value]) {
      return <small>{statusDate?.[statusInfo?.value]}</small>;
    }

    return null;
  }, [statusInfo, statusDate]);

  if (isBlock === undefined) return null;

  return (
    <Container
      title={statusInfo?.msg}
      $color={statusInfo?.color}
      $isFaint={isBlock}
    >
      <div className="timeline-content">
        <div className="inner-circle" />
        {title()}
        {date()}
      </div>
    </Container>
  );
}

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 0.1rem;

  @media (min-width: 768px) {
    &:not(:last-child):after {
      content: '';
      display: block;
      border-top: 0.25rem dotted ${colors.primaryLight};
      width: 2.8rem;
      position: absolute;
      left: 7.5rem;
      top: 0.3125rem;
    }
    &:not(:first-child):before {
      content: '';
      display: block;
      border-top: 0.25rem dotted ${colors.primaryLight};
      width: 2.5rem;
      position: absolute;
      right: 7.5rem;
      top: 0.3125rem;
    }
    .timeline-content {
      width: 10rem;
      text-align: center;

      .inner-circle {
        border-radius: 1.5rem;
        height: 1rem;
        width: 1rem;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background-color: ${(props) =>
          props.$color ? colors[props.$color] : colors.primaryLight};
        opacity: ${(props) => (props.$isFaint ? '0.3' : '1')};

        &:before {
          content: '';
          background-color: ${(props) =>
            props.$color ? colors[props.$color] : colors.primaryLight};
          display: inline-block;
          height: 3rem;
          width: 3rem;
          min-width: 3rem;
          border-radius: 6.25rem;
          opacity: ${(props) => (props.$color ? '0.5' : '0.3')};
        }
      }
    }
  }
`;
